export default function ({ route, redirect, app }) {
  if (route.fullPath === '/school' || route.fullPath === '/school/' || route.fullPath === '/school/list' || route.fullPath === '/school/list/') {
    redirect(app.localePath({ name: app.$routeName.school, params: { param1: 'tehran' } }))
  }
}
